import { isPresent } from "@/lib/utils"

export const DEFAULT_TABBAR_LINKS = [
  {
    text: "Home",
    icon: "home",
    path: "/"
  },
  {
    text: "Schedule",
    icon: "calendar_today",
    path: "/me/schedule"
  },
  {
    text: "You",
    icon: "person",
    path: "/me/my-content"
  }
]

export default {
  namespaced: true,

  state: {
    showSidebar: false
  },

  mutations: {
    toggleSidebar(state) {
      state.showSidebar = !state.showSidebar
    },

    setShowSidebar(state, showSidebar = true) {
      state.showSidebar = showSidebar
    }
  },

  getters: {
    tabbarLinks(_, __, state) {
      return isPresent(state.global) &&
        isPresent(state.global.tabbar) &&
        isPresent(state.global.tabbar.links)
        ? state.global.tabbar.links
        : DEFAULT_TABBAR_LINKS
    },

    isTabbarShown(_, getters, state) {
      if (state.videos.isFullscreen) return false

      return state.responsive.isDesktop
        ? true
        : state.pages.currentPage &&
          getters.tabbarLinks
            .map(link => link.path)
            .includes(state.pages.currentPage.path)
        ? true
        : state.pages.currentPage?.type !== "workout" &&
          !state.pages.currentPage?.actions?.length
    }
  }
}
